module.exports = __webpack_public_path__ + "assets/img/medinserve_vip.1d7c488e.png";